import Step2DefaultHomepageContent from "./Steps/Step2DefaultHomepageContent.jsx";
import Step2DefaultContactContent from "./Steps/Step2DefaultContactContent.jsx";

import BasicHomepage from "./Templates/BasicHomepage.jsx";
import BasicContactPage from "./Templates/BasicContactPage.jsx";

import defaultHomepageEditorConfig from "./EditorConfigs/defaultHomepageEditorConfig.js";
import defaultContactEditorConfig from "./EditorConfigs/defaultContactEditorConfig.js";

const defaultTemplates = {
  "default-homepage": {
    id: "default-homepage",
    name: "Basic",
    label: "Basic",
    desc: "Clean hero + about + CTA",
    pageType: "home",
    step2Component: Step2DefaultHomepageContent,
    publicComponent: BasicHomepage,
    editorConfig: defaultHomepageEditorConfig,
  },

  "default-contact": {
    id: "default-contact",
    name: "Contact",
    label: "Basic Contact",
    desc: "Simple contact page",
    pageType: "page",
    step2Component: Step2DefaultContactContent,
    publicComponent: BasicContactPage,
    editorConfig: defaultContactEditorConfig,
  },
};

export default defaultTemplates;